import { AfterViewInit, Component, HostListener, Inject, InjectionToken } from '@angular/core';
import { OverlayService }                                                 from '../../../core/services/overlay.service';
import { ESCAPE }                                                         from '@angular/cdk/keycodes';
import { animationStates, fade }                                          from '../../animations/animations';


export interface LightboxData {
  imageUrl: string;
  alt:      string;
}

export const RED_LIGHTBOX_DATA = new InjectionToken<LightboxData>('RedLightboxData');

@Component(
  {
    selector:    'red-lightbox',
    templateUrl: './lightbox.component.html',
    styleUrls:   [ './lightbox.component.scss' ],
    animations:  [ fade ]
  }
)
export class LightboxComponent implements AfterViewInit {

  public animationState: animationStates;

  @HostListener('document:keydown', [ '$event' ])
  public handleKeydown(event: KeyboardEvent) {
    // noinspection JSDeprecatedSymbols
    if (event.keyCode === ESCAPE) this.close();
  }

  constructor(
    private overlayService: OverlayService,
    @Inject(RED_LIGHTBOX_DATA) public data: LightboxData
  ) {
    this.animationState = 'void';
  }

  public ngAfterViewInit(): void {
    setTimeout(() => this.animationState = 'enter', 0);
  }

  public close() {
    this.animationState = 'leave';
  }

  public animationDone() {
    if (this.animationState === 'leave') {
      this.animationState = 'void';
      this.overlayService.close('lightbox');
    }
  }
}
